class WarnLastDayController {
  constructor() {
    this.hideWarningCard = false;
  }

  hideWarningVacation(){
    this.hideWarningCard = true;
  }
}

export default WarnLastDayController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/warnLastDay/warnLastDay.controller.js